import React, { Component } from 'react';
import flow from 'lodash/flow';
import { CheckboxSelect } from '@atlaskit/select';
import ComponentWithAnalytics from '@atlassian/jira-analytics-web-react/src/utils/component-with-analytics.tsx';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import type { ProjectTypeId, ProjectTypeSelectOption } from '../model/types.tsx';
import messages from './messages.tsx';

export type Props = {
	readonly isInitiallyOpen: boolean;
	readonly isLoading: boolean;
} & Intl & {
		readonly projectTypes: ProjectTypeSelectOption[];
		readonly onChange: (arg1: ProjectTypeId[]) => void;
	} & { ariaLabelText?: string };

type State = {
	isOpen: boolean;
};

const getCustomStyles = () => ({
	// @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
	option: (base) => ({
		...base,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	}),
	// @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
	container: (base) => ({
		...base,
		minWidth: 220,
	}),
});

// eslint-disable-next-line jira/react/no-class-components
export class ProjectTypePicker extends Component<Props, State> {
	static defaultProps = {
		isInitiallyOpen: false,
		isLoading: false,
	};

	onSelectionChange = (selectedItems: ProjectTypeSelectOption[]) => {
		// Adding null check due to https://ecosystem.atlassian.net/jira/servicedesk/projects/DS/queues/issue/DS-7451
		const selectedItemValues = selectedItems ? selectedItems.map((el) => el.value) : [];
		this.props.onChange(selectedItemValues);
	};

	onIsOptionSelected = (option: ProjectTypeSelectOption): boolean => option.isSelected;

	isLoading() {
		return this.props.isLoading && this.state.isOpen;
	}

	renderFormattedOptionLabel = (option: ProjectTypeSelectOption) => option.content;

	render() {
		const {
			intl: { formatMessage },
			projectTypes,
			isInitiallyOpen,
			ariaLabelText,
		} = this.props;

		const selectedProjectType = projectTypes.filter((projectType) => projectType.isSelected);

		return (
			<CheckboxSelect
				aria-label={ariaLabelText}
				isMulti
				spacing="compact"
				isSearchable={false}
				options={projectTypes}
				placeholder={formatMessage(messages.allProjectTypesSpork)}
				defaultMenuIsOpen={isInitiallyOpen}
				// @ts-expect-error - TS2322 - Type '(selectedItems: ProjectTypeSelectOption[]) => void' is not assignable to type '(value: OptionsType<OptionType>, action: ActionMeta<OptionType>) => void'.
				onChange={this.onSelectionChange}
				formatOptionLabel={this.renderFormattedOptionLabel}
				isOptionSelected={this.onIsOptionSelected}
				value={selectedProjectType}
				styles={getCustomStyles()}
			/>
		);
	}
}

export default flow(
	ComponentWithAnalytics('projectTypePicker', {
		onChange: 'changed',
	}),
	injectIntl,
)(ProjectTypePicker);
